import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class ClubPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.clubRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.clubImport,
    );
    this.clubAutocomplete = permissionChecker.match(
      Permissions.values.clubAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.clubCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.clubEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.clubDestroy,
    );
  }
}
